

const InvEconCalendar = () => (
  <div className="w-[600] bg-black mx-auto overflow-hidden">
<iframe className="-mt-10  " src="https://sslecal2.investing.com?ecoDayBackground=%23000000&defaultFont=%23000000&innerBorderColor=%23000000&borderColor=%23000000&ecoDayFontColor=%23ffffff&columns=exc_flags,exc_currency,exc_actual,exc_forecast,exc_previous&countries=25,34,32,6,37,72,71,22,17,51,39,14,33,10,35,43,60,38,36,110,11,26,9,12,4,5&calType=week&timeZone=15&lang=51" width="600" height="480" frameBorder="0" marginWidth="0" marginHeight="0"></iframe>

    </div>
)



export default InvEconCalendar